/** Site branding & share meta for pob.zhong88.net (not pob.cool). */

export const SITE_TITLE = "PoE2 网页 PoB";
export const SITE_NAME = "PoE2 网页 PoB";
export const SITE_HOST = "pob.zhong88.net";

export const SITE_DESCRIPTION =
  "基于 Path of Building PoE2 的网页版，支持中文显示、装备导入与 Trade 链接生成。";
export const SITE_TAGLINE = "流放之路 2 浏览器版 Path of Building · 非官方 · 非 GGG 附属";
export const OG_DESCRIPTION =
  "支持简体中文、繁體中文、装备导入、计算与 Trade Find best 链接生成。";

export const SITE_ORIGIN = "https://pob.zhong88.net";
export const OG_IMAGE = `${SITE_ORIGIN}/favicon.png`;
export const OG_IMAGE_ALT = "PoE2 网页 PoB";

export const ATTRIBUTION = {
  pobWeb: { name: "pob-web (Koji AGAWA)", url: "https://github.com/atty303/pob-web" },
  pobPoe2: { name: "PathOfBuilding-PoE2", url: "https://github.com/PathOfBuildingCommunity/PathOfBuilding-PoE2" },
} as const;
